import React from 'react'

export default function Footer() {
  return (
    <div>       
      <nav className="navbar bg-light mt-5" style={{boxShadow:"rgb(246 246 246) 0px -20px 20px 0px", borderTop:"2px solid white"}}>
        <div className="container text-center d-flex justify-content-center align-items-center pt-3">
            <p>Copyright &copy; Giga Chat 2023, All Rights Reserved</p>
        </div>
        </nav>
    </div>
  )
}
